// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#css__jQ0pM8{background:transparent;margin-bottom:0!important;margin-top:0!important;padding-bottom:0!important;padding-top:0!important;position:relative}#css__jQ0pM8 .css__yBe4Dn{left:0;position:absolute;top:0;width:100%;z-index:6}@media (max-width:65rem){#css__jQ0pM8 .css__yBe4Dn{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page_content": "css__jQ0pM8",
	"banner_breadcrumbs": "css__yBe4Dn"
};
module.exports = ___CSS_LOADER_EXPORT___;
